import { install } from './install'

export default class SimpleUI {
  static install = install
}
